<template>
  <canvas
    id="myCanvas"
    class="canvas"
    width="98%"
    :style="[backgroundImage]"
    style="border: 1px solid #000; background-size: 100% 100%;width:98%;"
    @touchstart.prevent="start($event)"
    @touchmove.prevent="move($event)"
    @touchend.prevent="end"
    @mousedown="start"
    @mousemove="move"
    @mouseup="end"
  ></canvas>
</template>

<script>
import CloseIcon from "@/assets/close.png";
import ScaleIcon from "@/assets/放大.png";
var close = new Image();
var scale = new Image();
close.src = CloseIcon;
scale.src = ScaleIcon;

class DragImg {
  constructor(img, canvas) {
    this.x = 30;
    this.y = 30;
    this.w = img.width;
    this.h = img.height;
    this.url = img.url;
    this.ctx = canvas;
    this.rotate = 0;
    this.selected = true;
    this.name = img.name;
  }

  paint() {
    this.ctx.save();
    this.centerX = this.x + this.w / 2;
    this.centerY = this.y + this.h / 2;

    this.ctx.translate(this.centerX, this.centerY);
    this.ctx.rotate((this.rotate * Math.PI) / 180);
    this.ctx.translate(-this.centerX, -this.centerY);

    this.ctx.drawImage(this.url, this.x, this.y, this.w, this.h);
    if (this.selected) {
      this.ctx.setLineDash([10, 10]);
      this.ctx.lineWidth = 2;
      this.ctx.strokeStyle = "red";
      this.ctx.lineDashOffset = 10;
      this.ctx.strokeRect(this.x, this.y, this.w, this.h);
      this.ctx.drawImage(close, this.x - 12, this.y - 12, 24, 24);
      this.ctx.drawImage(
        scale,
        this.x + this.w - 12,
        this.y + this.h - 12,
        24,
        24
      );
    }
    this.ctx.restore();
  }

  isInWhere(x, y) {
    const transformW = 24;
    const transformH = 24;
    let transformX = this.x + this.w;
    let transformY = this.y + this.h;
    console.log("this:", this.x, this.y, this.w, this.h, this.name);
    const transformAngle =
      (Math.atan2(transformY - this.centerY, transformX - this.centerX) /
        Math.PI) *
        180 +
      this.rotate;
    console.log(
      "trans before:",
      transformX,
      transformY,
      transformAngle,
      this.rotate
    );
    const tranImg = this.getTransform(transformX, transformY, transformAngle);
    transformX = tranImg.x;
    transformY = tranImg.y;
    const diffTX = tranImg.x - x - 12;
    const diffTY = tranImg.y - y - 12;
    console.log("trans after:", tranImg, diffTX, diffTY);
    const delW = 24;
    const delH = 24;
    let delX = this.x;
    let delY = this.y;
    const delAngle =
      (Math.atan2(delY - this.centerY, delX - this.centerX) / Math.PI) * 180 +
      this.rotate;
    const delXY = this.getTransform(delX, delY, delAngle);
    delX = delXY.x;
    delY = delXY.y;
    const diffDX = delXY.x - x + 12;
    const diffDY = delXY.y - y + 12;
    console.log("del after:", delXY, diffDX, diffDY);

    const moveX = this.x;
    const moveY = this.y;
    const diffX = x - this.x;
    const diffY = y - this.y;
    console.log("move = del?:", delXY, diffX, diffY);
    // if (
    //   x - transformX >= 0 &&
    //   y - transformY >= 0 &&
    //   transformX + transformW - x >= 0 &&
    //   transformY + transformH - y >= 0
    // ) {
    if (diffTX >= 0 && diffTX <= 24 && diffTY >= 0 && diffTY <= 24) {
      return "transform";
      // } else if (
      //   x - delX >= 0 &&
      //   y - delY >= 0 &&
      //   delX + delW - x >= 0 &&
      //   delY + delH - y >= 0
      // ) {
    } else if (diffDX >= 0 && diffDX <= 24 && diffDY >= 0 && diffDY <= 24) {
      return "del";
      // } else if (
      //   x - moveX >= 0 &&
      //   y - moveY >= 0 &&
      //   moveX + this.w - x >= 0 &&
      //   moveY + this.h - y >= 0
      // ) {
    } else if (diffX >= 0 && diffX < this.w && diffY >= 0 && diffY < this.h) {
      return "move";
    }
    return false;
  }

  getTransform(x, y, rotate) {
    var angle = (Math.PI / 180) * rotate;

    var r = Math.sqrt(
      Math.pow(x - this.centerX, 2) + Math.pow(y - this.centerY, 2)
    );

    var a = Math.sin(angle) * r;

    var b = Math.cos(angle) * r;
    // console.log("a,b", a, b);
    return {
      x: this.centerX + b - 12,
      y: this.centerY + a - 12
    };
  }
}
export default {
  name: "canvas-drag",
  props: {
    backImg: String,
    imgArr: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      ctx: null,
      dragArr: [],
      clickedkArr: [],
      c: null,
      lastImg: null,
      initial: {
        initialX: "",
        initialY: "",
        startX: "",
        startY: "",
        initialRotate: ""
      },
      startTouch: { startX: "", startY: "" },
      ctxRect: {}
    };
  },
  computed: {
    backgroundImage() {
      console.log("s", this.$props);
      return {
        "background-image": "url('" + this.backImg + "')",
        "background-size": "100% 100%"
      };
    }
  },

  methods: {
    draw() {
      this.ctx.clearRect(0, 0, this.c.width, this.c.height);
      this.dragArr.forEach(item => {
        item.paint();
      });
    },
    start(e) {
      this.moving = true;
      this.clickedkArr = [];
      console.log("start:", e);
      const x =
        e.type == "touchstart"
          ? e.touches[0].clientX - this.ctxRect.left
          : e.offsetX;
      const y =
        e.type == "touchstart"
          ? e.touches[0].clientY - this.ctxRect.top
          : e.offsetY;
      //const x = e.clientX
      //const y = e.clientY
      console.log("start:", x, y, this.ctxRect);

      this.dragArr.forEach((item, index) => {
        const place = item.isInWhere(x, y);
        console.log("place:", place);
        item.place = place;
        item.index = index;
        item.selected = false;
        if (place) {
          this.clickedkArr.push(item);
        }
      });
      const length = this.clickedkArr.length;

      if (length) {
        const lastImg = this.clickedkArr[length - 1];
        if (lastImg.place === "del") {
          // this.dragArr.splice(lastImg.index, 1); //for test
          this.draw();
          // return;
        }
        lastImg.selected = true;
        this.lastImg = lastImg;

        this.initial = {
          initialX: lastImg.x,
          initialY: lastImg.y,
          initialH: lastImg.h,
          initialW: lastImg.w,
          initialRotate: lastImg.rotate
        };
      }
      this.draw();
      this.startTouch = { startX: x, startY: y };
    },
    move(e) {
      if (!this.moving) {
        return;
      }
      const x =
        e.type == "touchmove"
          ? e.touches[0].clientX - this.ctxRect.left
          : e.offsetX;
      const y =
        e.type == "touchmove"
          ? e.touches[0].clientY - this.ctxRect.top
          : e.offsetY;
      //const x = e.clientX
      //const y = e.clientY
      console.log("move:", x, y, e);

      const { initialX, initialY } = this.initial;
      const { startX, startY } = this.startTouch;

      const lastImg = this.lastImg;

      if (this.clickedkArr.length) {
        if (this.lastImg.place === "move") {
          lastImg.x = initialX + (x - startX);
          lastImg.y = initialY + (y - startY);
        }

        if (this.lastImg.place === "transform") {
          const { centerX, centerY } = lastImg;
          const { initialRotate } = this.initial;

          const angleBefore =
            (Math.atan2(startY - centerY, startX - centerX) / Math.PI) * 180;
          const angleAfter =
            (Math.atan2(y - centerY, x - centerX) / Math.PI) * 180;

          lastImg.rotate = initialRotate + angleAfter - angleBefore;

          const { initialH, initialW } = this.initial;

          const lineA = Math.sqrt(
            Math.pow(centerX - startX, 2) + Math.pow(centerY - startY, 2)
          );
          const lineB = Math.sqrt(
            Math.pow(centerX - x, 2) + Math.pow(centerY - y, 2)
          );

          const w = initialW + (lineB - lineA);
          const h = initialH + (lineB - lineA) * (initialH / initialW);

          lastImg.w = w <= 5 ? 5 : w;
          lastImg.h = h <= 5 ? 5 : h;

          if (w > 5 && h > 5) {
            lastImg.x = initialX - (lineB - lineA) / 2;
            lastImg.y = initialY - (lineB - lineA) / 2;
          }
        }
        this.draw();
      }
    },
    end(e) {
      console.log("end:", e);
      if (this.moving) {
        this.moving = false;
      }
    },
    drawBackground() {
      var img = new Image();
      img.src =
        "https://senkoo.oss-cn-shanghai.aliyuncs.com/products/WL-20SS%20UPJ071188731.jpg";
      img.onload = () => {
        this.ctx.drawImage(img, 0, 0, this.c.width, this.c.height);
      };
    }
  },
  watch: {
    imgArr(arr) {
      if (arr.length) {
        const newImg = arr.slice(-1)[0];
        const item = new DragImg(newImg, this.ctx);
        this.dragArr.push(item);
        this.draw();
      }
    },
    backImg(str) {
      // console.log("asd", str);
    }
  },

  mounted() {
    const c = document.getElementById("myCanvas");
    this.c = c;
    const { width, height } = window.screen;
    c.width = width - 2;
    c.height = height * 0.75;
    this.ctx = c.getContext("2d");
    this.ctxRect = c.getBoundingClientRect();
    //var background  = new Image()
    //background.src = "https://senkoo.oss-cn-shanghai.aliyuncs.com/products/WL-20SS%20UPJ071188731.jpg"
    //background.onload = () => {
    //    this.ctx.drawImage(background, 0, 0,  c.width, c.height)
    //}
  }
};
</script>
<style scope>
#myCanvas {
}
</style>
